import React, { Component } from "react";
import {Row, Col} from "antd";
import { Card } from 'antd';

export default class UserInformation extends Component {
	render() {
		const user = this.props.user;

		return (
			<Row className="UserInformation">
				{user.handle &&
					<Col xs={ { span: 20 } }  sm={ { span: 12 } } md={ { span: 10 } } lg={ { span: 6 } } xl={ { span: 5 } } style={ { margin: "auto", float: "none" } }>
						<Card
							hoverable
							style={{ width: "80%", margin: "auto" }}
							cover={<img alt="avatar" src={ user.titlePhoto } />}
						>
							<h3 className="UserInformation__handle">{ user.handle }</h3>
							
							<h4>Solved problems: { user.solvedProblems }</h4>

							<div className="UserInformation__location">
								<div className="UserInformation__location-country">
									{ user.country }
								</div>
								
								<div className="UserInformation__location-city">
									{ user.city }
								</div>
							</div>

							<div className="UserInformation__organization">
								{ user.organization }
							</div>

							<div className="UserInformation__rating">
								<p className="UserInformation__rating-maxRank">Max rating: { user.maxRating } ({ user.maxRank })</p>
								<p className="UserInformation__rating-maxRank">Rating: { user.rating } ({ user.rank })</p>
							</div>
						</Card>
					</Col>
				}
			</Row>
		)
	}
}
